import { render, staticRenderFns } from "./PayrollPage.vue?vue&type=template&id=04b62ef0&"
import script from "./PayrollPage.vue?vue&type=script&lang=js&"
export * from "./PayrollPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports